import { useTranslation } from 'react-i18next';
import { Button } from '@kizen/kds/Button';
import { Card, Header, ButtonWrapper } from './styles';
import { Typography } from '@kizen/kds/Typography';
import { Spacer } from '@kizen/kds/Spacer';

interface SignOutProps {
  padding?: string;
  onLogout: () => void;
  openKizen: () => void;
}

export const SignOutMessage = ({
  padding,
  onLogout,
  openKizen,
}: SignOutProps) => {
  const { t } = useTranslation();

  return (
    <Card padding={padding}>
      <Header>
        <Typography size="2xl">{t('Kizen Session')}</Typography>
        <Spacer size={30} />
        <Typography size="xl">
          {t('You are currently logged into Kizen in a different window.')}
        </Typography>
      </Header>

      <ButtonWrapper>
        <Button color="secondary" onClick={openKizen}>
          {t('Open Kizen')}
        </Button>
        <Button onClick={onLogout}>{t('Logout to Continue')}</Button>
      </ButtonWrapper>
    </Card>
  );
};
